/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentConsequences.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Consequence API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, January 21, 2019 - 12:43:41 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Consequences = {
    all: () => requests.get('/Consequences'),
    get: consequenceid => requests.get(`/Consequence/${consequenceid}`),
    create: consequence => requests.post(`/Consequences`, consequence),
    update: (consequenceid, consequence) => requests.put(`/Consequence/${consequenceid}`, consequence),
    delete: consequenceid => requests.del(`/Consequence/${consequenceid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentConsequences.js